<template>
  <div class="row diac-lemonway">
    <div class="col-lg-12">
      <div class="ibox">
        <div class="ibox-title">
          <h5><i class="fa fa-credit-card-alt"></i> IBAN client acheteur</h5>
        </div>
        <div class="ibox-content">
          <p>
            IBAN : <span class="text-navy">{{ iban }}</span>
            <br/>
            BIC : <span class="text-navy">{{ bic }}</span>
          </p>
          <p>
            Nom de la banque : <span class="text-navy">Lemonway</span>
            <br />
            Adresse de la banque : <span class="text-navy">{{ address }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "IbanBuyer",
  props: {
    customerId: {
      type: String,
      required: true
    },
  },
  data: () => ({
    iban: process.env.VUE_APP_LEMONWAY_IBAN,
    bic: process.env.VUE_APP_LEMONWAY_BIC,
    address: process.env.VUE_APP_LEMONWAY_ADDRESS,
  }),
  mounted () {
    this.getIban(this.customerId)
  },
  methods: {
    async getIban(id) {
      await this.$apollo.query({
        query: gql`
                query {
                  getIban (customerId: ${id}) {
                    iban
                    bic
                    status
                  }
                }`
      }).then((res) => {
        if (res && res.data.getIban.status === 5) {
          this.iban = res.data.getIban.iban;
          this.bic = res.data.getIban.bic;
        }
      })
    },
  }
}
</script>